namespace Matrix.Data {
    export class SecurityColumns {
        static columnsKey = 'Data.Security';
    }
}
